import { useNewCode } from '@calendly/feature-check-react'

export const useNewAdminModal = () => useNewCode('activation_q3', false)?.enabled
